import { DateInput, Select } from "components";
import moment from "moment";
import { delevery_option } from "pages/Card/Transaction/CreateNewVendor/utils";
import { useListBillDropdown, useListPO } from "pages/Purchase/Register/components/TabAllBills/hooks";
import { useEffect } from "react";
import { APPROVAL_OPTIONS } from "utils";

interface FilterSectionProps {
    activeTab?: number
    dateFrom: string;
    dateTo: string;
    onChangeDateFrom: (data: string) => void;
    onChangeDateTo: (data: string) => void;
    approval?: string,
    onChangeApproval: (approval: string) => void
    onChangeDelivered: (delivered: string) => void
    delevery?: string,
    onChangePo: (po: string) => void
    po?: string
    onChangeStatus: (status: string) => void
    status?: string
    onChangeBill: (po: string) => void
    bill?: string
}

export function FilterSection({
    activeTab,
    dateFrom,
    dateTo,
    onChangeDateFrom,
    onChangeDateTo,
    approval,
    onChangeApproval,
    delevery,
    onChangeDelivered,
    po,
    onChangePo,
    status,
    onChangeStatus,
    bill,
    onChangeBill,
}: FilterSectionProps) {

    const approvalOptions = [
        { label: "All", value: "" },
        ...APPROVAL_OPTIONS
    ];

    const statusDropdown = [
        { label: "All", value: "" },
        { label: "Open", value: "1" },
        { label: "Close", value: "2" },
        { label: "Credit", value: "3" }
    ]


    return (
        <section className="flex gap-3">
            <DateInput
                label="START DATE"
                placeholderText="Date From"
                onChange={(date) =>
                    onChangeDateFrom(moment(date).format("YYYY-MM-DD"))
                }
                selected={moment(dateFrom).toDate()}
            />

            <DateInput
                label="END DATE"
                placeholderText="Date To"
                selected={moment(dateTo).toDate()}
                onChange={(date) => onChangeDateTo(moment(date).format("YYYY-MM-DD"))}
                maxDate={moment(dateFrom).add(30, "days").toDate()}
            />

            <div className="w-[150px]">
                <Select
                    label="APPROVAL"
                    className=""
                    value={approvalOptions.find(
                        (item) => item.value === approval?.toString()
                    )}
                    options={approvalOptions}
                    onChange={(res) => {
                        if (res?.value !== undefined) {
                            onChangeApproval(res.value)
                        }
                    }}
                />
            </div>

            {
                activeTab === 0 && (
                    <div className="w-[150px]">
                        <Select
                            label="DELIVERY"
                            value={delevery_option.find(
                                (item) => item.value === delevery
                            )}
                            options={delevery_option}
                            onChange={(res) => {
                                if (res) {
                                    onChangeDelivered(res.value)
                                }
                            }}
                        />
                    </div>
                )}

            {activeTab === 1 && (
                <>

                <DropdownPo 
                    po={po} 
                    onChangePo={onChangePo} 
                    dateFrom={dateFrom} 
                    dateTo={dateTo}
                />

                    <div className="w-[150px]">
                        <Select
                            label="STATUS"
                            value={statusDropdown.find(
                                (item) => item.value === status
                            )}
                            options={statusDropdown}
                            onChange={(res) => {
                                if (res) {
                                    onChangeStatus(res.value)
                                }
                            }}
                        />
                    </div>

                </>


            )}

            {activeTab === 4 && (
                <DropdownBill
                    bill={bill}
                    onChangeBill={onChangeBill}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                />
            )}

        </section>
    );
}


function DropdownPo(props: {
    po: string | undefined,
    onChangePo: (po: string) => void,
    dateFrom: string,
    dateTo: string
}) {
    const { dataPO, isLoadingPO, refetchPO } = useListPO()
    const sortedSelectDummy = [
        { label: "All", value: "" },
        ...dataPO.sort((a, b) => parseInt(b.value) - parseInt(a.value))
    ];

    useEffect(() => {
        if (props.dateFrom && props.dateTo) { refetchPO({ DateFrom: props.dateFrom, DateEnd: props.dateTo }) }

        // eslint-disable-next-line
    }, [props.dateFrom, props.dateTo])


    return (
        <div className="w-[150px]">
            <Select
                label="PO"
                isLoading={isLoadingPO}
                options={sortedSelectDummy}
                value={sortedSelectDummy.find(
                    (item) => item.value.toString() === props.po
                )}
                onChange={(res) => {
                    if (res) {
                        props.onChangePo(res.value)
                    }
                }}
            />
        </div>
    )
}


function DropdownBill(props: {
    bill: string | undefined,
    onChangeBill: (bill: string) => void,
    dateFrom: string,
    dateTo: string
}) {
    const { dataBill, isLoadingBill, refetchBill } = useListBillDropdown()
    const sortedSelectDummy = [
        { label: "All", value: "" },
        ...dataBill.sort((a, b) => parseInt(b.value) - parseInt(a.value))
    ];

    useEffect(() => {
        if (props.dateFrom && props.dateTo) { refetchBill({ DateFrom: props.dateFrom, DateEnd: props.dateTo }) }

        // eslint-disable-next-line
    }, [props.dateFrom, props.dateTo])


    return (
        <div className="w-[150px]">
            <Select
                label="BILL ID"
                isLoading={isLoadingBill}
                options={sortedSelectDummy}
                value={sortedSelectDummy.find(
                    (item) => item.value.toString() === props.bill
                )}
                onChange={(res) => {
                    if (res) {
                        props.onChangeBill(res.value)
                    }
                }}
            />
        </div>
    )
}
